import { render, staticRenderFns } from "./ChooseSize.vue?vue&type=template&id=4ddbe2f3"
import script from "./ChooseSize.vue?vue&type=script&lang=js"
export * from "./ChooseSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports